/**
 * balance-ships.ts — ship-production balance knobs (M10).
 *
 * Mirrors balance-structures.ts / balance-detection.ts: every tunable
 * number for the production pipeline lives here, `advance-shipyard.ts`
 * and the `buildShip` command applier read from this file, tests assert
 * shape against these constants rather than hard-coding numerics.
 */


/**
 * Build duration for a ship of Class Level N, in ticks. 100..600 ticks =
 * roughly 10..60 seconds at the 10 Hz sim rate. Monotone in class level so
 * Class 6 capital ships take a meaningful slice of real time to produce.
 * Balance pass may retune, or swap to a data-driven per-chassis field in
 * Ships.xlsx if per-chassis variance becomes important.
 *
 * v3M10.1: migrated to state.balanceData.build.ticksByClass.
 */

import type { BalanceData } from '../state/types/index';

export function buildTicksByClass(balance: BalanceData) {
  return balance.build.ticksByClass;
}

/**
 * Spawn-ring radius around the building planet's (systemX, systemY). A
 * newly-built ship appears on this ring at a random angle so multiple
 * ships rolling off the same line don't stack at one point. Smaller than
 * the starter-ring (0.09 in scenario.ts) so new builds feel tucked in
 * near their origin planet rather than sprayed across the system.
 *
 * v3M10.1: migrated to state.balanceData.build.shipSpawnRingRadius.
 */
